import styled from 'styled-components'

export const Container = styled.div`
  border-radius: 10px;
  box-shadow: 0px 1px 3px #00000029;
  background-color: #ffffff;
  min-height: 80px;
  width: 100%;
  padding: 20px;
`

export const WrapperTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  .subtitle {
    color: #898989;
  }
`